import cc from 'classcat';
import { useRef, useCallback, useEffect } from 'react';
import { setAlphaOnColor } from '@i-ark/utils';
import { tableCls, tableBodyCls, rowCls, cellCls, cellFontSizeExtraLargeCls, cellFontSizeLargeCls, cellFontSizeMediumCls, cellFontSizeSmallCls } from './Table.style.js';
import { jsx } from 'react/jsx-runtime';
import { useScale } from '../hooks/useScale.js';

const Table = ({
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  defaultTextColor,
  defaultInputColor,
  isSelected,
  isCloned,
  onSelect,
  TableCell
}) => {
  const ref = useRef(null);
  const scale = useScale();
  const borderWidth = `${Math.max(1, Math.round(2 * scale)).toString()}px`;
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    node.addEventListener("focusin", handleSelect, {
      passive: false
    });
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("focusin", handleSelect);
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);
  return /*#__PURE__*/jsx("table", {
    ref: ref,
    className: tableCls,
    "data-id": item.id,
    style: {
      zIndex,
      left: `${(item.position.x * 100).toString()}%`,
      top: `${(item.position.y * 100).toString()}%`,
      width: `${(item.size.width * 100).toString()}%`,
      height: `${(item.size.height * 100).toString()}%`,
      borderTop: `${borderWidth} solid #000`,
      borderLeft: `${borderWidth} solid #000`
    },
    children: /*#__PURE__*/jsx("tbody", {
      className: tableBodyCls,
      children: item.cells.map((row, rowIndex) => {
        return /*#__PURE__*/jsx("tr", {
          className: rowCls,
          style: {
            height: `${item.rowHeight[rowIndex]?.toString()}%`,
            borderBottom: `${borderWidth} solid #000`
          },
          children: row.map((cell, columnIndex) => {
            const fontSize = cell.style.font?.size ?? item.font.size;
            return /*#__PURE__*/jsx("td", {
              className: cc([cellCls, {
                [cellFontSizeSmallCls]: fontSize === "small",
                [cellFontSizeMediumCls]: fontSize === "medium",
                [cellFontSizeLargeCls]: fontSize === "large",
                [cellFontSizeExtraLargeCls]: fontSize === "extra-large"
              }]),
              style: {
                width: `${item.columnWidth[columnIndex]?.toString()}%`,
                backgroundColor: setAlphaOnColor(cell.style.background.color, cell.style.background.opacity ?? 1),
                borderRight: `${borderWidth} solid #000`,
                color: cell.style.font?.color ?? item.font.color ?? (cell.kind === "text" ? defaultTextColor : defaultInputColor)
              },
              children: /*#__PURE__*/jsx(TableCell, {
                sheetRef: sheetRef,
                pageId: pageId,
                pageAspectRatio: pageAspectRatio,
                item: item,
                cell: cell,
                isSelected: isSelected,
                isCloned: isCloned
              })
            }, cell.id);
          })
        }, row[0]?.id);
      })
    })
  });
};

export { Table };
//# sourceMappingURL=Table.js.map
